var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.862,
    height: 11.243,
    viewBox: "0 0 18.862 11.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12142",
    "data-name": "Group 12142",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49609",
    "data-name": "Path 49609",
    d: "M9.431,98.725c-3.6,0-6.872,1.972-9.283,5.174a.747.747,0,0,0,0,.891c2.411,3.206,5.68,5.178,9.283,5.178S16.3,108,18.714,104.794a.747.747,0,0,0,0-.891C16.3,100.7,13.035,98.725,9.431,98.725Zm.259,9.58a3.967,3.967,0,1,1,3.7-3.7A3.97,3.97,0,0,1,9.689,108.305Zm-.12-1.829a2.136,2.136,0,1,1,1.995-1.995A2.133,2.133,0,0,1,9.57,106.477Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSm);
export default __webpack_public_path__ + "static/media/eyeSm.ca4c88c0c1bc03bb5f5a127d54ccf980.svg";
export { ForwardRef as ReactComponent };